import type { SVGProps } from 'react';

import { strokeStyle } from '../Illustration.css';
import { useIllustrationShades } from '../Illustration.hooks';

type Props = SVGProps<SVGSVGElement> & {
  strokeWidth: number;
};

export const Coins = ({ strokeWidth, ...delegated }: Props) => {
  const shades = useIllustrationShades();

  return (
    <svg fill="none" height="112" viewBox="0 0 83 112" width="83" xmlns="http://www.w3.org/2000/svg" {...delegated}>
      <path
        className={strokeStyle}
        d="M63.9 92.69a5.3 5.3 0 0 1-1.24 2.6c-1.16 1.4-3.08 2.64-5.57 3.66a35 35 0 0 1-5.5 1.68c-5.28 1.2-11.86 1.68-18.94 1.22q-2.53-.16-4.95-.46h-.05c-11.86-1.5-21.22-5.44-24-9.97q-.92-1.48-.83-3.02c.26-4.07 6.12-7.29 14.74-8.8-1.67 1.35-3.3 3.5-1.67 6.23.68 1.14 1.94 2.38 4 3.7 5.14 3.3 18.83 5.18 30.41 4.75a90 90 0 0 0 13.6-1.59Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m63.91 92.69-.42 5.62c-.17 2.66-2.72 4.95-6.85 6.65l.45-6c2.49-1.03 4.4-2.26 5.57-3.67a5.3 5.3 0 0 0 1.24-2.6z"
        fill={shades.primary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m51.59 100.63-.45 6c-5.28 1.2-11.86 1.69-18.94 1.23q-2.13-.15-4.18-.37c-1.33-.86-2.91-2.14-2.98-3.42-.06-1.38 1.5-2.23 2.67-2.67q2.4.3 4.95.46c7.08.46 13.66-.03 18.94-1.22z"
        fill={shades.primary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M28.01 107.49C13.17 105.76 2 100.2 2.37 94.39v-.11l.45-5.89a5 5 0 0 0 .83 3.02c2.77 4.53 12.14 8.47 24 9.97h.05c-1.18.44-2.73 1.29-2.67 2.67.07 1.28 1.64 2.56 2.98 3.42z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m57.09 98.95-.45 6a36 36 0 0 1-5.51 1.7l.45-6a35 35 0 0 0 5.5-1.69Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="m63.93 92.43-.02.26" strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M63.94 92.3v.13l-.04.26-3 .53c-3.05.48-6.7.91-10.6 1.06-11.58.43-25.27-1.46-30.41-4.75-2.06-1.32-3.32-2.57-4-3.7-1.63-2.72 0-4.89 1.67-6.23a71 71 0 0 1 16.56-.75C51 79.93 64.35 85.96 63.94 92.32z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M24.9 31.55q-7.15-.42-4.08 6.13c-11.9-8.7-18.46-19.39-14.9-25l3.95-6.22a6.6 6.6 0 0 0-.96 3.75c.13 5.92 6.31 14.29 15.99 21.34Z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M61.57 39.3a6.6 6.6 0 0 1-2.98 2.47q-2.02.9-4.83.98-2.76.08-6.1-.58c-5.7-1.13-12.42-3.89-19.05-8.09a68 68 0 0 1-3.7-2.52c-9.68-7.05-15.87-15.43-16-21.34a6.6 6.6 0 0 1 .96-3.76c3.94-6.19 18.7-3.85 32.97 5.22s22.67 21.44 18.74 27.61z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m47.66 42.17-3.96 6.22c-5.7-1.14-12.42-3.89-19.04-8.1a69 69 0 0 1-3.84-2.61q-3.07-6.54 4.09-6.13 1.77 1.29 3.7 2.52c6.62 4.21 13.35 6.97 19.05 8.1Z"
        fill={shades.primary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m61.57 39.3-3.95 6.23c-1.4 2.2-4.17 3.32-7.82 3.44l3.96-6.22q2.8-.09 4.82-.98a6.6 6.6 0 0 0 2.98-2.47z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m53.76 42.75-3.95 6.22c-1.83.06-3.9-.13-6.1-.57l3.95-6.23q3.33.66 6.1.58Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path d="m38.74 17.8 5.78 5.92-3.37.54-2.9-2.96-3.39.54 2.9 2.96-3.38.54-5.8-5.91z" fill={shades.black} />
      <path
        className={strokeStyle}
        d="M46.93 60.18a41 41 0 0 1-11.99 2.5c-8.4.54-17.34-1.17-25.67-4.69q-.93-.4-1.84-.82a4.2 4.2 0 0 1 .11-2.7c2.2-5.24 16.61-4.2 32.22 2.33a89 89 0 0 1 7.17 3.37Z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m64.06 78.1-.18.35c-.59 1.06-1.73 1.83-3.32 2.33-5.63 1.74-16.84-.04-28.72-5.01l-1.9-.82C22.79 71.77 16.77 68 12.73 64.38a24 24 0 0 1-4-4.43q-.54-.84-.89-1.61-.26-.6-.41-1.17.92.43 1.84.82c8.33 3.52 17.27 5.23 25.67 4.7a41 41 0 0 0 11.99-2.51C58.55 66.3 65.89 73.7 64.06 78.1Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M64.06 78.1q-.07.18-.18.35z" strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="m8.75 59.96-3.2 6.55c-1.36-2.07-1.82-3.96-1.2-5.48l.18-.37 1.92-3.95q.49.25.97.46.15.56.41 1.17.35.79.9 1.6z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="m4.53 60.66-.17.37q.06-.2.17-.37Z" fill={shades.primary.dark} strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="m12.74 64.39-3.2 6.55a24 24 0 0 1-3.97-4.43l3.19-6.55q1.41 2.13 3.99 4.43z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M26.42 81.34c-7-3.14-12.9-6.85-16.88-10.41l3.19-6.55c4.04 3.62 10.06 7.39 17.2 10.57-5.04-.08-5.41 2.52-3.51 6.4Z"
        fill={shades.primary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m63.88 78.45-3.01 6.18c-2.19 5.24-16.61 4.2-32.22-2.33q-1.13-.47-2.22-.96c-1.9-3.87-1.53-6.47 3.52-6.4l1.9.83c11.9 4.97 23.1 6.75 28.72 5 1.59-.49 2.73-1.26 3.32-2.32Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M7.54 54.48 6.46 56.7" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="m26.52 81.54-.1-.19" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M77.78 10.85v7.94" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M80.58 14.82h-5.6" strokeWidth={strokeWidth} />
    </svg>
  );
};
